/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol } from 'sarsaparilla';
import RenderIf from '../utils/JSXUtils';
import { formatPrice } from '../utils';

const Line = PropTypes.shape({
    description: PropTypes.string,
    quantity: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.number,
});

export default class CostsTable extends PureComponent {
    static defaultProps = {
        showNoLinesText: false,
    };

    static propTypes = {
        attendeeInfo: PropTypes.node,
        lines: PropTypes.arrayOf(Line).isRequired,
        total: Line.isRequired,
        showNoLinesText: PropTypes.bool,
    };

    static renderLine = (line, attendeeInfo) => {
        const { title, description, value } = line;
        if (!value) return null;

        const cost = formatPrice(value);
        const totalCost = title === 'Total Cost';
        const subTotal = title === 'Subtotal';

        let className = totalCost ? 'activitypass-costs-table-total-cost' : '';
        if (subTotal) className = 'activitypass-costs-table-subtotal';

        return (
            <FlexRow
                hasGutters={false}
                key={title}
                className={`activitypass-costs-table-item-wrap ${className}`}
            >
                <FlexCol xs={6} md={8} xl={6} className="activitypass-costs-table-name">
                    {title}
                    {RenderIf(description)(<span>{description}</span>)}
                    {attendeeInfo && (
                        <div className="activitypass-reservation-summary-attendee-info-wrap">
                            {attendeeInfo}
                        </div>
                    )}
                </FlexCol>
                <FlexCol xs={6} md={4} xl={6} className="activitypass-costs-table-cost">
                    {cost}
                </FlexCol>
            </FlexRow>
        );
    };

    render() {
        const { attendeeInfo, lines, total, showNoLinesText } = this.props;

        return (
            <div className="activitypass-costs-table">
                {lines.map((line, index) =>
                    CostsTable.renderLine(line, index ? null : attendeeInfo)
                )}
                {showNoLinesText && <p>No options selected.</p>}
                {CostsTable.renderLine(total)}
            </div>
        );
    }
}

// cspell:ignore activitypass
